export default "__VITE_ASSET__W3uDiE7V__"